interface StatusPillProps {
    label: string;
    backgroundColor: string;
    textColor?: string;
    minWidth?: string;
    fontWeight?: number | string;
}

export default function TextPill({label, backgroundColor, textColor = "#fff", minWidth = "96px", fontWeight = 600}: StatusPillProps) {
    return (
        <span
            style={{
                display: "inline-block",
                padding: "6px 12px",
                borderRadius: "999px",
                backgroundColor,
                color: textColor,
                fontWeight,
                minWidth,
                textAlign: "center"
            }}
        >
            {label}
        </span>
    );
}
